import useDsToast from '@/components/design-system/toast/useDsToast';
import type {
    FileTableColumn,
    FileTableDisplayRow,
    FileTableExportOptions,
} from '@/components/Views/Company/File/file-table.types';
import { useClipboard } from '@vueuse/core';
import { toValue } from 'vue';

const CELL_SEPARATOR = '\t';
const ROW_SEPARATOR = '\n';

const formatCellForClipboard = (cell: FileTableDisplayRow[FileTableColumn['field']]) =>
    typeof cell === 'string' || typeof cell === 'number' ? String(cell).trim() : '';

export const useFileTableExport = ({ dataTable, columns, rows }: FileTableExportOptions) => {
    const { copy } = useClipboard({ legacy: true });
    const { addToast } = useDsToast();

    const exportCsv = () => dataTable.value?.exportCSV();

    const exportClipboard = async () => {
        const exportedColumns = toValue(columns);
        const header = exportedColumns.map(column => column.header).join(CELL_SEPARATOR);
        const body = toValue(rows).map(row =>
            exportedColumns.map(column => formatCellForClipboard(row[column.field])).join(CELL_SEPARATOR),
        );

        await copy([header, ...body].join(ROW_SEPARATOR));

        addToast({
            detail: 'Data copied to clipboard',
        });
    };

    return {
        exportCsv,
        exportClipboard,
    };
};
